import { Injectable, inject } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';
import { TokenService } from '../services/token.service';

@Injectable()
export class SessionExpiredInterceptor implements HttpInterceptor {
  readonly #router = inject(Router);
  readonly #tokenService = inject(TokenService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.#requestIsExcluded(request.url)) {
      return next.handle(request);
    }

    // if (!this.#tokenService.isValidToken()) {
    //   this.#closeSession();
    //   return throwError(() => new Error('Sesion vencida'));
    // }

    return next.handle(request).pipe(
      catchError((error: unknown) => {
        console.log('error ejejeje');
        console.log(error);
        if (error instanceof HttpErrorResponse && error?.error?.message.includes('User is not authorized to access this resource with an explicit deny in an identity-based policy')) {
          this.#closeSession();
        }

        return throwError(() => error);
      })
    );
  }

  #closeSession(): void {
    sessionStorage.clear();
    void this.#router.navigate(['/']).then(() => {
      window.location.reload();
    });
  }

  #requestIsExcluded(url: string): boolean {
    return [
      'loginMotorAdmin',
      'cataloge',
      's3.amazonaws.com',
      '/api/v1/'
    ].some(route => url.includes(route));
  }
}
